module.exports = __webpack_public_path__ + "img/university-df2.837f944e.png";